import { useState } from 'react';
import {
  useListProvidersBySite,
  useListRemittanceBySite,
  useListReportsBySite,
  useListSubmissionsBySite,
} from 'api/resource';
import { useListPayors } from 'api/resource/payor';
import { MRT_ColumnFiltersState, MRT_SortingState } from 'mantine-react-table';
import { useCurrentSiteStore } from 'store/SiteStore';

export const useUserReportManagementData = () => {
  const site = useCurrentSiteStore();
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
    globalFilter: '',
    columnFilters: [] as MRT_ColumnFiltersState,
    sorting: [] as MRT_SortingState,
  });

  const reportsResult = useListReportsBySite({
    siteID: site.id,
    page: pagination.pageIndex,
    pageSize: pagination.pageSize,
    filters: pagination.columnFilters,
    globalFilter: pagination.globalFilter,
    sorting: pagination.sorting,
  });
  const providersResult = useListProvidersBySite({ siteID: site.id });
  const submissionsResult = useListSubmissionsBySite({ siteID: site.id });
  const remittanceResult = useListRemittanceBySite({ siteID: site.id });
  const payorsResult = useListPayors();
  const isLoading = [
    reportsResult.isLoading,
    providersResult.isLoading,
    submissionsResult.isLoading,
    remittanceResult.isLoading,
    payorsResult.isLoading,
  ].some((loading) => loading);
  const isError = [
    reportsResult.isError,
    providersResult.isError,
    submissionsResult.isError,
    remittanceResult.isError,
    payorsResult.isError,
  ].some((error) => error);
  const isFetching = [
    reportsResult.isFetching,
    providersResult.isFetching,
    submissionsResult.isFetching,
    remittanceResult.isFetching,
    payorsResult.isFetching,
  ].some((fetching) => fetching);
  const errorMessage = [
    reportsResult.error?.message,
    providersResult.error?.message,
    submissionsResult.error?.message,
    remittanceResult.error?.message,
    payorsResult.error?.message,
  ].find((message) => message);
  return {
    reports: reportsResult.data?.data || [],
    sites: [site],
    providers: providersResult.data || [],
    submissions: submissionsResult.data || [],
    payors: payorsResult.data || [],
    remittances: remittanceResult.data || [],
    totalReports: reportsResult.data?.total || 0,
    isLoading,
    isError,
    isFetching,
    errorMessage,
    refetchReports: reportsResult.refetch,
    pagination,
    setPagination,
  };
};
